
import { Component, Vue } from 'vue-property-decorator'
import GoodsResultCard from "@/views/goodsManage/mall/shop/template/GoodsResultCard.vue";
import { ShopGoodsListDto } from "@/api/shoppingMall";
import { Getter } from "vuex-class";
import { getGoodsByBarcode } from "@/api/commonConfig";

@Component({
  name: 'ShopBarCodeGoods',
  components: { GoodsResultCard }
})
export default class ShopBarCodeGoods extends Vue {
  @Getter companyId!: string
  @Getter providerId!: string

  goodsList: ShopGoodsListDto[] = []
  params = {
    pageIndex: 1,
    pageSize: 20,
    shopId: '',
    customerId: '',
    barcode: ''
  }
  isFirstEnter = true // 用于区分是否是第一次进入此页面

  created () {
    this.params.shopId = this.providerId
    this.params.customerId = this.companyId
    this.params.barcode = this.$route.query.barcode as string
    // this.params.shopId= '61b70183d5e8c83638c49279'
    // this.params.customerId = '61b701fad5e8c83638c493d9'
    // this.params.barcode = '6901028208932',
    // this.getGoodsList(true)
  }

  activated () {
    if (this.isFirstEnter) {
      this.getGoodsList(true)
      this.isFirstEnter = false
    } else {
      this.getGoodsList(false)
    }
  }

  /**
   * 获取扫码商品列表
   * @param isShowMsg 是否显示扫码成功提示
   */
  getGoodsList (isShowMsg = false) {
    getGoodsByBarcode(this.params).then((res) => {
      this.goodsList = res.data || []
      if (this.goodsList.length > 0) {
        // 不提示
        // isShowMsg && this.$toast('扫码成功')
      } else {
        this.$toast('找不到对应商品')
      }
    })
  }

  reloadList () {
    this.params.pageIndex = 1
    this.getGoodsList()
  }

  toScan () {
    this.$bridge.callHandler('toQRCodePage', {}, (res: string) => {
      this.params.barcode = res
      this.params.pageIndex = 1
      this.getGoodsList(true)
    })
  }

}
